import { getSupportedTimeBuckets, timeBuckets, timeBucketToBucketCategory, } from '@thoughtspot/date-format-util';
import { areRestrictedTimeBucketsEnabled, areStrictDateColumnsEnabled, areStrictDateColumnsEnabledByDefault, } from '@thoughtspot/session-service';
import { getEffectiveDataType } from '@thoughtspot/visualization-column-util';
import _ from 'lodash';
import { FalconDataType } from '../types';
export const getTimeBucketMenuItems = (column, translate) => {
    let isTimeBucketChangeRestricted = false;
    const getTimeBucketItem = (timeBucket) => ({
        label: translate(`timeBucketLabels.${timeBucket}`),
        isSelected: _.findKey(timeBuckets, bucket => bucket === timeBucket) ===
            column.timeBucket,
        itemDisabled: isTimeBucketChangeRestricted,
        itemDisabledTooltip: translate('axisMenu.disabledTooltip.restrictedTimeBucket'),
        id: _.findKey(timeBuckets, bucket => bucket === timeBucket).toString(),
    });
    let supportedTimeBuckets = getSupportedTimeBuckets(getEffectiveDataType(column));
    if (areRestrictedTimeBucketsEnabled() && column.isTimeBucketRestricted) {
        isTimeBucketChangeRestricted = true;
        supportedTimeBuckets = _.pickBy(supportedTimeBuckets, value => _.findKey(timeBuckets, bucket => bucket === value) ===
            column.timeBucket);
    }
    else if (column.dataType === FalconDataType.Date &&
        (areStrictDateColumnsEnabledByDefault() ||
            (areStrictDateColumnsEnabled() && column.isStrictDateColumn))) {
        supportedTimeBuckets = _.pickBy(supportedTimeBuckets, value => value !== timeBuckets.HOURLY);
    }
    const timeBucketCategories = _.groupBy(supportedTimeBuckets, (bucket) => timeBucketToBucketCategory[bucket]);
    return _.map(timeBucketCategories, (buckets, category) => {
        return buckets.length === 1
            ? getTimeBucketItem(_.first(buckets))
            : {
                label: translate(`timeBucketCategory.${category}`),
                cascadingItems: [
                    {
                        title: `${category} Time Bucket`,
                        items: buckets.map(getTimeBucketItem),
                    },
                ],
                id: _.findKey(timeBuckets, bucket => bucket === category).toString(),
            };
    });
};
//# sourceMappingURL=menu.util.js.map